export enum FeatureFlags {
  UI_REFRESH = "designControlsUiRefresh",
  COMPARE_VIEW = "designControlsComparisonView",
  TRACEABILITY_LIMIT = "designControlsTraceabilityLimit",
  CONFIGURABLE_POLICY = "design-controls-configurable-prefix-generation",
  API_V2 = "design-controls-fargate-api",
}
